<template>
  <div class="flags">
    <div class="flags__controls">
      <b-form-select id="flag-filter" v-model="filter" :options="filter_options" class="mb-3" />
    </div>
    <b-table striped hover :items="flags" :fields="fields" :filter="filter">
        <template slot="pdp_url" slot-scope="data">
          {{ data.item.pdp_url.substr(data.item.pdp_url.lastIndexOf('/') + 1) }}
        </template>
        <template slot="image_url" slot-scope="data">
          <img class="ImageFlag__img" :src="data.item.image_url">
        </template>
        <template slot="action" slot-scope="data">
          <a :href="'https://backoffice.getgrover.com/operations/products/' + data.item.pdp_url.substr(data.item.pdp_url.lastIndexOf('/') + 1) + '/variants'" target="blank"><b-button size="sm">View on Backoffice</b-button></a>
        </template>
    </b-table>
    
  </div>
</template>

<script>
// @ is an alias to /src
import Vuex from 'vuex'

import './Flags.sass'

export default {
  name: 'flags',
  computed: Vuex.mapState(['flags','lowRes']),
  data() {
    return {
      fields: [
      {
        key: 'image_url',
        label: "",
        sortable: false
      },
      {
        key: 'amount',
        sortable: true,
        label: 'Amount'
      },
      {
        key: 'pdp_url',
        label: "Slug",
        sortable: true
      },
      {
        key: 'type',
        sortable: false
      },
      {
        key: 'action',
        sortable: false,

      }
      ],
      filter: "",
      filter_options: [
        { value: "", text: "Filter by type..."},
        { value: "non-transparent-image", text: "Missing transparency"},
        { value: "low-res-image", text: "Low resolution image"},
      ]
    } 
  },
  created () {
    this.$store.dispatch('init')
  },
  mounted() {
    console.log(this.$store.state.flags)
  },
  methods: {
    sort: function () {
        this.flags.sort(this.sortAlphaNum);
    },
    reverse: function () {
        this.flags.reverse();
    },
    sortAlphaNum: function (a,b) {
      var aA = a.timestamp
      var bA = b.timestamp
      if(aA === bA) {
          var aN = parseInt(a.timestamp, 10);
          var bN = parseInt(b.timestamp, 10);
          return aN === bN ? 0 : aN > bN ? 1 : -1;
      } else {
          return aA > bA ? 1 : -1;
      }
    }
  }
}
</script>
